'use strict';
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/delete-property-or-throw.js
// module id = 154
// module chunks = 0